import { CollapsibleServiceMenu, SubMenuServiceLink } from '@netapp/bxp-design-system-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { leftNav as i18nNamespace } from "../../../../../../i18n/namespace";

const SelectedServiceCollpasibleMenuNav = React.memo(({ serviceItem, isActiveTab, getRoute }) => {
    const { t } = useTranslation(i18nNamespace);
    const location = useLocation();
    const activeFeatures = useSelector(state => state.features.active);

    const enabledSubMenus = (serviceItem.subMenus || []).filter(childItem =>
        !childItem.featureId || activeFeatures[childItem.featureId]
    );

    if (enabledSubMenus.length === 0) {
        return null;
    }

    // Deep links into a sub menu should land with its section already open.
    const isSectionActive = isActiveTab(location, serviceItem)
        || enabledSubMenus.some(childItem => isActiveTab(location, childItem));

    return (
        <CollapsibleServiceMenu
            label={t(serviceItem.label)}
            isExpandedByDefault={isSectionActive}
            isExpanded={isSectionActive ? true : undefined}
        >
            {enabledSubMenus.map(childItem => (
                <SubMenuServiceLink
                    key={childItem.to}
                    to={getRoute(childItem)}
                    isActive={(match, location) => isActiveTab(location, childItem)}
                >
                    {t(childItem.label)}
                </SubMenuServiceLink>
            ))}
        </CollapsibleServiceMenu>
    );
});

export default SelectedServiceCollpasibleMenuNav;
